import React, { useEffect, useRef } from 'react'
import { Option, OptionsList } from './style'
import { ParamType, StructureType } from '../..'
import { useOutletContext } from 'react-router-dom'
import { CertificateOutletType } from '../../..'
import editIcon from '../../../../../../assets/global-assets/edit.svg'
import trashIcon from '../../../../../../assets/global-assets/trash.svg'

interface PropsType {
  onClose: React.Dispatch<React.SetStateAction<null>>
  setParam: React.Dispatch<React.SetStateAction<ParamType>>
  structure: StructureType
}

const OptionsDropdown:React.FC<PropsType> = ({onClose, setParam, structure}) => {
  const { setModal, setClickedStructure } = useOutletContext<CertificateOutletType>()
  const dropdownRef = useRef<HTMLUListElement | null>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        onClose(null)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [onClose])

  const handleRemoveStructure = (id: number) => {
    setParam(prev => ({
      ...prev,
      structures: prev.structures.filter((item) => item.id !== id)
    }))
    onClose(null)
  }
  
  return (
    <OptionsList ref={dropdownRef}>
      {/* <Option>Visualizar</Option> comentado pois nunca vi em uso */} 
      <Option onClick={() => {
        setModal(true)
        setClickedStructure(structure.id)
        onClose(null)
      }}> <img src={editIcon} alt='edit-icon' /> Editar</Option>
      <Option onClick={() => handleRemoveStructure(structure.id)}> <img src={trashIcon} alt='trash-icon' /> Remover</Option>
    </OptionsList>
  )
}

export default OptionsDropdown